// extracted by mini-css-extract-plugin
export default {"filterBoxMenu":"dropdown_filterBoxMenu__Oh3ES","item":"dropdown_item__49hgU"};